import { Outlet, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { EmpresasListWrapper } from './empresas-list/EmpresasList'

const ApiPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path=''
          element={
            <>
              <PageTitle description={t('pagina.api.descricao')}>APIs</PageTitle>
              <EmpresasListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default ApiPage
